import { render, staticRenderFns } from "./SimilarRecommendation.vue?vue&type=template&id=bb6937c4&scoped=true"
import script from "./SimilarRecommendation.vue?vue&type=script&lang=js"
export * from "./SimilarRecommendation.vue?vue&type=script&lang=js"
import style0 from "./SimilarRecommendation.vue?vue&type=style&index=0&id=bb6937c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6937c4",
  null
  
)

export default component.exports